
import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  Grid,
  Typography,
  Button,
  Link as MuiLink,
} from '@material-ui/core'

import CONFIG from '../../config'
import Link from '../controls/Link'

import SmallArrowRight from '../../../assets/images/icons/ico_arrow_small.svg'

class ErrorView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    error: PropTypes.shape({
      text: PropTypes.string.isRequired,
      subtext: PropTypes.string,
    }),
    onRestart: PropTypes.func,
  }

  static defaultProps = {
    error: {
      subtext: '',
    },
    onRestart: null,
  }

  static styles = (theme) => ({
    errorText: {
      marginBottom: '32px',
    },
    buttonContained: theme.buttonContained,
    link: theme.loginLink,
  })

  renderReturnToSignIn = () => {
    const { classes, onRestart } = this.props
    const text = 'Return to sign in'
    if (onRestart) {
      return (
        <MuiLink href="#" onClick={onRestart} className={classes.link}>
          {text}
        </MuiLink>
      )
    }
    return (
      <MuiLink component={Link} to="/login" className={classes.link}>
        {text}
      </MuiLink>
    )
  }

  render() {
    const {
      classes,
      error,
    } = this.props

    return (
      <>
        <div className={classes.errorText}>
          <Typography variant="h1">{error.text}</Typography>
          <Typography variant="h2">{error.subtext}</Typography>
        </div>
        <Grid container justify="space-between" alignItems="center">
          <Grid item>
            <Button
              href={`mailto:${CONFIG.blokable.supportEmail}`}
              variant="contained"
              color="primary"
              classes={{ contained: classes.buttonContained }}
            >
              Customer support
              <img src={SmallArrowRight} alt="→" />
            </Button>
          </Grid>
          <Grid item>
            {this.renderReturnToSignIn()}
          </Grid>
        </Grid>
      </>
    )
  }
}

export default withStyles(ErrorView.styles)(ErrorView)
